import React from 'react';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import OuvidoriaFilter from './OuvidoriaFilter';
import OuvidoriaHeader from './OuvidoriaHeader';
import OuvidoriaTable from './OuvidoriaTable';
import { useOuvidoriaListagem, useOuvidoriaNavegacao } from '../hooks';

const OuvidoriaCard = ({
  showActions = true,
  enableRowClick = true,
  showFilter = true,
  showHeader = true,
}) => {
  const {
    data,
    loading,
    filterLoading,
    totalRegistros,
    paginaAtual,
    quantidadePorPagina,
    filtrosUI,
    motivoOptions,
    tagOptions,
    handleFilterApply,
    handleLimparFiltros,
    handleExcluir,
    setPaginaAtual,
    setQuantidadePorPagina,
  } = useOuvidoriaListagem();

  const { handleAdicionar, handleEditar, handleRowClick } = useOuvidoriaNavegacao();

  return (
    <Card>
      <CardBody>
        {showHeader && (
          <OuvidoriaHeader
            totalRegistros={totalRegistros}
            onAdicionar={showActions ? handleAdicionar : undefined}
          />
        )}

        {showFilter && (
          <OuvidoriaFilter
            loading={filterLoading}
            values={filtrosUI}
            motivoOptions={motivoOptions}
            tagOptions={tagOptions}
            onApply={handleFilterApply}
            onLimpar={handleLimparFiltros}
          />
        )}

        <OuvidoriaTable
          data={data}
          loading={loading}
          onRowClick={enableRowClick ? handleRowClick : undefined}
          onEditar={showActions ? handleEditar : undefined}
          onExcluir={showActions ? handleExcluir : undefined}
          manualPagination={true}
          totalRegistros={totalRegistros}
          controlledPagination={{
            pageIndex: Math.max(0, (paginaAtual || 1) - 1),
            pageSize: quantidadePorPagina || 10,
          }}
          onPaginationChange={next => {
            if (next && typeof next.pageSize === 'number') {
              setQuantidadePorPagina(next.pageSize);
            }

            if (next && typeof next.pageIndex === 'number') {
              setPaginaAtual(next.pageIndex + 1);
            }
          }}
        />
      </CardBody>
    </Card>
  );
};

export default OuvidoriaCard;
